import { Component, ReactNode } from 'react';
import { ApiConnectionError, ApiError, ApiHttpError } from './apiHttpError';
import Unauthorized from '@/routes/admin/Unauthorized';
import DownTimeScreen from '@/components/DownTimeScreen';

interface MainErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  isAuthError: boolean;
  isBackendDown: boolean;
  error: Error | null;
}

export class MainErrorBoundary extends Component<MainErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: MainErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, isAuthError: false, error: null, isBackendDown: false };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    if (error instanceof ApiError) {
      if (error instanceof ApiConnectionError) {
        return {
          hasError: true,
          isAuthError: false,
          isBackendDown: true,
          error: error,
        };
      }
      if (error instanceof ApiHttpError) {
        return {
          hasError: true,
          isAuthError: error.response.status === 403 || error.response.status === 401,
          isBackendDown:
            (error.response.status >= 500 && error.response.status <= 511) ||
            error.response.status === 408,
          error: error,
        };
      }
    }
    return {
      hasError: true,
      isAuthError: false,
      isBackendDown: false,
      error: error instanceof Error ? error : new Error('An error occurred: ' + String(error)),
    };
  }

  render() {
    const { hasError, isAuthError, isBackendDown } = this.state;
    if (hasError) {
      if (isAuthError) {
        return <Unauthorized />;
      } else if (isBackendDown) {
        return <DownTimeScreen />;
      }
      // return <DownTimeScreen />;
    }

    return this.props.children;
  }
}
